import { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import UploadFile from "../../Components/UploadFile";
import moment from "moment";
import { useCookies } from "react-cookie";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Pagination from "../../Components/Pagination";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import SubscriptionsSelectList from "../../Components/SubscriptionsSelectComponent";
const number = new RegExp("^[+]?([0-9]{0,})*[,]?([0-9]{0,2})?$", "g");

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function UploadReceipt(props) {
  const apiToken = useContext(TokenContext);

  const [value, setValue] = useState();
  const [uploadFile, setUploadFile] = useState(false);
  const [validation, setValidation] = useState(false);
  const [validationFile, setValidationFile] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [data, setData] = useState();
  const [isAlertVisible, setIsAlertVisible] = useState();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);

  const [subFileTemp, setSubFileTemp] = useState();
  const [subFile, setSubFile] = useState();

  const [fileName, setFilename] = useState("");

  const [isDisabled, setIsDisabled] = useState(false);

  const ref = useRef();
  let query = useQuery();
  const [isOpenReceipt, toggleModalReceipt] = useState(false);
  const [removableReceipt, setRemovableReceipt] = useState();

  useEffect(() => {
    if (query.get("scroll")) {
      window.scrollTo(0, ref.current.offsetHeight + 150);
    }
  }, []);

  useEffect(() => {
    let timer;
    if (isAlertVisible) {
      timer = setTimeout(() => {
        setIsAlertVisible(false);
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isAlertVisible]);

  const loadSubscriptionFiles = () => {
    Repo.getSubscriptionFileUser(apiToken)
      .then((response) => {
        setSubFile([]);
        setSubFileTemp([]);
        setSubFile(response.data);
        setSubFileTemp(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    loadSubscriptionFiles();
  }, []);

  useEffect(() => {
    if (query.get("scroll")) {
      window.scrollTo(0, ref.current.offsetHeight + 150);
    }
  }, []);

  const [previouslySelectedOption, setPreviouslySelectedOption] =
    useState(null);

  const handleSelectedOptionChange = (selectedOption) => {
    setPreviouslySelectedOption(selectedOption);

    setIsDisabled(selectedOption);
  };

  const handleIsEmpty = (selectedOption) => {
    setIsDisabled(selectedOption);
  };

  const sendReceipt = async () => {
    setValidation(true);
    setValidationFile(true);

    let passedValidation = true;

    let tempData = {};
    const d = moment();

    if (uploadFile) {
      var splitBase64 = uploadFile.split(",");

      const mimeType = splitBase64[0]; // Il tipo MIME completo
      const parts = mimeType.split(";"); // Suddivide la stringa in base al carattere ';'
      const imageType = parts[0].split(":")[1]; // Rimuovi "data:" dalla parte centrale

      tempData["base64"] = splitBase64[1];
      tempData["type"] = imageType;
    } else {
      passedValidation = false;
      setValidationFile(false);
    }

    var localFormat = "YYYY-MM-DD[T]HH:mm:ss";

    tempData["year"] = d.year();
    tempData["date"] = d.format(localFormat);
    tempData["name"] = fileName;

    if (value == "" || value == " " || !value) passedValidation = false;

    tempData["value"] = value?.replace(".", "").replace(",", ".");
    tempData["subscriptionId"] = previouslySelectedOption.value;
    if (passedValidation) {
      var dataJson = JSON.stringify(tempData);
      setData(dataJson);
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  const showFile = (id, fileName) => {
    Repo.downloadFileUser(apiToken, id)
      .then((response) => {
        if (response.status === 200) {
          // Decodifica i dati Base64 in un array di byte
          const byteCharacters = atob(response.data);

          // Crea un array di byte
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Crea un oggetto Blob dallo stream di byte
          const blob = new Blob([byteArray], {
            type: response.headers["content-type"],
          });

          // Crea un URL oggetto temporaneo per il blob
          const url = URL.createObjectURL(blob);

          // Crea un link e configurarlo per il download
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName; // Specificare il nome del file

          // Aggiungi il link al corpo del documento e fai clic su di esso per avviare il download
          document.body.appendChild(link);
          link.click();

          // Rimuovi il link dal corpo del documento dopo il download
          document.body.removeChild(link);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  const sendReceiptApi = async () => {
    setLoading(false);

    Repo.postSendSubscriptionFile(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          setIsAlertVisible(true);

          toggleModal(false);
          loadSubscriptionFiles();
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setLoading(true);
  };

  const removeReceipt = async () => {
    setLoading(false);

    Repo.delEliminaAllegatoIscrizione(apiToken, removableReceipt)
      .then((response) => {
        if (response.status == 204) {
          setIsAlertVisible(true);
          toggleModalReceipt(false);
          loadSubscriptionFiles();
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setLoading(true);
  };

  return (
    <>
      <h1>Caricamento ricevute</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Carica una nuova ricevuta. La nuova ricevuta dovrà essere validata.
        </p>
      </div>
      {isDisabled && (
        <div className="alert alert-danger" role="alert">
          Non è possibile caricare un allegato.
        </div>
      )}

      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom">
          <div className="card-body">
            <div className="row mb-5">
              <div className="col-12">
                <SubscriptionsSelectList
                  apiToken={apiToken}
                  previouslySelectedOption={previouslySelectedOption}
                  onSelectedOptionChange={handleSelectedOptionChange}
                  onIsEmpty={handleIsEmpty}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-8">
                <UploadFile
                  setErrorMessage={setErrorMessage}
                  typeFile={[
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "application/pdf",
                  ]}
                  handleFile={setUploadFile}
                  nameFile={setFilename}
                ></UploadFile>

                {errorMessage && (
                  <div className="text-danger">
                    Carica un file con un formato supportato
                  </div>
                )}
                {validation && !validationFile ? (
                  <div className="text-danger">
                    Non è stato caricato nessun documento
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="col-lg-4 pl-5">
                <label className="active" htmlFor="input-group-3">
                  Importo
                </label>
                <div className="row mb-4">
                  <Input
                    id="value"
                    value={value}
                    name="Importo"
                    disabled={isDisabled}
                    onChange={(e) =>
                      setValue(
                        e.target.value.match(number) ? e.target.value : value
                      )
                    }
                    {...(validation &&
                      (value == "" || value == " " || !value) && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div",
                      })}
                  />
                </div>
                <div className="row my-2">
                  <div className="col-lg-12 text-right">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      disabled={isDisabled}
                      onClick={() => sendReceipt()}
                      title="Conferma"
                    >
                      Invia
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom">
          <div className="card-body" key="isee" ref={ref}>
            <div className="categoryicon-top">
              <svg className="icon">
                <use href={`${iconSprite}#it-copy`}></use>
              </svg>
              <span className="text">
                ({subFile ? subFile.length : 0}) File Caricati
              </span>
            </div>

            {subFile && subFile.length > 0 ? (
              subFile.map((x, index) => (
                <div key={index}>
                  <div className="row">
                    <div className="col-lg-3 text-left">
                      <strong>{x.announcementName}</strong>
                    </div>
                    <div className="col-lg-2 text-left">
                      Importo: &nbsp;
                      <strong>{x.description}</strong>
                    </div>
                    <div className="col-lg-3 text-left">
                      Data inserimento: <strong>{x.dataInsert}</strong>
                    </div>

                    <div className="col-lg-2 text-left">
                      {x.state == "1" ? (
                        <div>
                          <b className="text-success">
                            <svg className="icon icon-success">
                              <use href={`${iconSprite}#it-check-circle`} />
                            </svg>{" "}
                            ACCETTATO
                          </b>
                        </div>
                      ) : x.state == "0" ? (
                        <b className="text-warning">
                          <svg className="icon icon-warning">
                            <use href={`${iconSprite}#it-close-circle`} />
                          </svg>
                          DA VERIFICARE
                        </b>
                      ) : x.state == "2" ? (
                        <b className="text-danger">
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-close-circle`} />
                          </svg>{" "}
                          RIFIUTATO
                        </b>
                      ) : (
                        <b className="text-danger">
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-close-circle`} />
                          </svg>{" "}
                          {x.state}
                        </b>
                      )}
                    </div>
                    <div className="col-lg-2 text-right">
                      <button
                        className="btn btn-outline-primary  p-1 ml-1"
                        type="button"
                        data-toggle="tooltip"
                        data-placement="top"
                        onClick={() => showFile(x.storageFileId, x.name)}
                        title="Visualizza"
                      >
                        <svg className="icon icon-primary ">
                          <use href={`${iconSprite}#it-file`} />
                        </svg>
                      </button>

                      {x.state == "0" ? (
                        <button
                          className="btn btn-outline-danger p-1 ml-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="È possibile eliminare la ricevuta solo quando è in stato di  DA VERIFICARE "
                          onClick={() => {
                            toggleModalReceipt(!isOpenReceipt);
                            setRemovableReceipt(x.storageFileId);
                          }}
                        >
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      ) : (
                        <button
                          className="btn btn-outline-secondary disabled p-1 ml-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Non è possibile cancellare la ricevuta!"
                        >
                          <svg className="icon icon-secondary">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                  <hr></hr>
                </div>
              ))
            ) : (
              <>Non sono presenti ricevute</>
            )}
            {subFileTemp && (
              <div className="mt-3">
                <Pagination
                  items={subFileTemp}
                  setCurrentItems={setSubFile}
                  itemsPerPage={5}
                ></Pagination>
              </div>
            )}
          </div>
        </div>
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento Ricevuta"
        body="Confermi di voler caricare la ricevuta?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendReceiptApi()}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalReceipt}
        isOpen={isOpenReceipt}
        header={"Rimozione documento:"}
        body={"Confermi di voler rimuovere il documento? "}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => removeReceipt()}
      ></ModalComponent>
      {isAlertVisible && (
        <>
          <div
            className="alert alert-success"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "22%",
              zIndex: 10000,
            }}
          >
            <b>
              Il caricamento è avvenuto con successo! Verrai reindirizzato
              all'Home Page.
            </b>
          </div>
        </>
      )}
      {!loading && <Loader></Loader>}
    </>
  );
}

export default UploadReceipt;
